import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { isAdminRole } from '../../../utils/mics';
import appActions from '../../../appActions';
import UserForm from './UserForm';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';

const UserFilterBar = (props) => {

    const dispatch = useDispatch();

    const user = useSelector((state) => state.user.userDetails);
    const { userInfo } = props;
    const { userRole } = userInfo;

    const storeOtions = useSelector((state) => state.common.storeList);
    const rolesOtions = useSelector((state) => state.common.rolesList);

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (user?.id) {
            setVisible(false);
            dispatch(appActions.USER_RESET_SUCCESS());
        }
    }, [user]);

    const formik = useFormik({
        initialValues: {
            userId: '',
            firstName: '',
            lastName: '',
            authType: '',
            authTypeValue: '',
            emailId: '',
            userGroup: user?.userGroup || "",
            siteId: null,
            sendNotificationBy: '',
            userRole: '',
            status: '',
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const data = {
                ...values,
                siteId: values?.siteId?.join(',') || '',
            };
            const params = data;
            Object.keys(params).forEach((key) => {
                if (params[key] === '') {
                    delete params[key];
                }
            });
            props.handleFilter(params);
        },
    });

    const handleReset = () => {
        formik.resetForm();
    };

    const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    };

    return (
        <>
            <Dialog
                header="Create a new user"
                visible={visible}
                style={{ width: '60vw' }}
                onHide={() => setVisible(false)}
            >
                <UserForm />
            </Dialog>

            <div className="flex mb-4 align-items-end">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex flex-wrap align-items-end gap-10 pb-0">
                        {/* Form Fields */}
                        <div className="form-group">
                            <label htmlFor="firstName" className="flex align-items-center"> First Name </label>
                            <InputText
                                className="w-full"
                                id="firstName"
                                value={formik.values.firstName}
                                onChange={formik.handleChange}
                                placeholder="First Name"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="lastName" className="flex align-items-center"> Last Name </label>
                            <InputText
                                className="w-full"
                                id="lastName"
                                value={formik.values.lastName}
                                onChange={formik.handleChange}
                                placeholder="Last Name"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="userId" className="flex align-items-center"> User Id </label>
                            <InputText
                                className="w-full"
                                id="userId"
                                value={formik.values.userId}
                                onChange={formik.handleChange}
                                placeholder="User ID"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="emailId" className="flex align-items-center"> Email Id </label>
                            <InputText
                                className="w-full"
                                id="emailId"
                                value={formik.values.emailId}
                                onChange={formik.handleChange}
                                placeholder="Email ID"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="userRole" className="flex align-items-center"> User Role </label>
                            <Dropdown
                                className="w-full"
                                value={formik.values.userRole}
                                options={rolesOtions}
                                onChange={(e) => formik.setFieldValue('userRole', e.value)}
                                placeholder="User Role"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="siteId" className="flex align-items-center"> Site Id </label>
                            <MultiSelect
                                className="w-full"
                                value={formik.values.siteId}
                                options={storeOtions}
                                id="siteId"
                                onChange={(e) => formik.setFieldValue('siteId', e.value)}
                                placeholder="Site Id"
                            />
                        </div>

                        {/* Buttons */}
                        <Button
                            type="submit"
                            icon="pi pi-search"
                            severity="basic"
                        />
                        {!isEmpty(props.filterParams) && (
                            <Button
                                onClick={handleReset}
                                icon="pi pi-times"
                                severity="secondary"
                                aria-label="Cancel"
                            />
                        )}
                    </div>
                </form>
                {isAdminRole(userRole) && (
                    <div className='flex justify-content-end ml-auto' style={{ minWidth: '200px' }}>
                        <div>
                            <Button
                                label="Create a New User"
                                severity="basic"
                                style={{ marginTop: '36px' }}
                                onClick={() => setVisible(true)}
                            />
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default UserFilterBar;
